import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { themeGet } from '@styled-system/theme-get';
import PropTypes from 'prop-types';

import { CreateDigest } from './CreateDigest';
import { TileDigest } from '../../../../shared/TileDigest';

function digestIsEmpty(tileDigests) {
  return (
    Object.entries(tileDigests).length === 0 &&
    tileDigests.constructor === Object
  );
}

const MonthContainer = styled.div`
  padding: 0 24px 16px;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
`;

const MonthContent = ({ tileDigests, addTileDigest, initialDate, month }) => {
  return (
    <MonthContainer>
      {tileDigests && !digestIsEmpty(tileDigests) ? (
        Object.keys(tileDigests)
          .sort()
          .map(bucketDate => (
            <TileDigest key={bucketDate} bucketDate={bucketDate} />
          ))
      ) : (
        <CreateDigest
          addTileDigest={addTileDigest}
          initialDate={initialDate}
          month={month}
        />
      )}
    </MonthContainer>
  );
};

MonthContent.propTypes = {
  tileDigests: PropTypes.object,
  addTileDigest: PropTypes.func,
  initialDate: PropTypes.string,
  month: PropTypes.string,
};

export { MonthContent };

export default connect()(MonthContent);
